import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";


export const searchCallCenterPerformanceReport = async (data) => {
    try {
        console.log("req data ccp",data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.REPORT}/call-center-performance-report/search`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error();
    }
};
